const thyroid =[

    {label:"Nodularity",
    controlType:"radio button",
    options:["Single nodule", "Multinodular", "Diffusely enlarged"]
    },

    {label:"Side",
    controlType:"checkbox group",
    options:["Right", "Left", "Central"]
    },

    {label:"Size (cm)",
    controlType:"text",
    options:[]
    },
    
    {label:"Consistency:",
    controlType:"radio button",
    options:["Hard", "Soft"]
    },

    {label:"Shape:",
    controlType:"radio button",
    options:["Smooth", "Irregular"]
    },

   
    {label:"Tenderness:",
    controlType:"radio button",
    options:["Tender", "Non-tender"]
    },

    {label:"Thyroid Auscultation:",
    controlType:"radio button",
    options:["Bruit", "No bruit"]
    },

    {label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    
    





]

export default thyroid